import { AccountListsV2, useAccountListsV2 } from '@ltvco/refresh-lib/v1';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function Lists() {
  const { data: lists, isLoading } = useAccountListsV2();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Report Lists - PeopleSmart';
  }, []);

  const redirectToSearchContactsPage = () => {
    navigate('/search/contact');
  };

  const brandReportTypes = [
    { value: 'all', display: 'All' },
    { value: 'reverse_phone_report', display: 'Phone' },
    { value: 'social_network_report', display: 'Email' },
    { value: 'username_report', display: 'Username' },
    { value: 'contact_report', display: 'Contact Pro' },
  ];

  return (
    <AccountListsV2
      lists={lists || []}
      isLoading={isLoading}
      customRedirectPath={redirectToSearchContactsPage}
      brandReportTypes={brandReportTypes}
    />
  );
}
